import { Link, useLocation } from 'react-router-dom';
import { Home, ShoppingBag, PlusCircle, User } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const MobileBottomNav = () => {
  const location = useLocation();
  const { isAuthenticated } = useAuth();
  
  const isActive = (path) => location.pathname === path;
  
  const navItems = [
    { href: '/', label: 'Home', icon: Home },
    { href: '/marketplace', label: 'Market', icon: ShoppingBag },
    { href: '/sell', label: 'Sell', icon: PlusCircle, requireAuth: true },
    { href: isAuthenticated ? '/dashboard' : '/login', label: 'Profile', icon: User },
  ];

  return (
    <nav className="mobile-bottom-nav md:hidden">
      <div className="flex items-center justify-around h-16">
        {navItems.map((item) => {
          if (item.requireAuth && !isAuthenticated) return null;
          
          const Icon = item.icon;
          const active = isActive(item.href);
          
          return (
            <Link
              key={item.href}
              to={item.href}
              className={`mobile-nav-item flex-1 ${active ? 'active' : ''}`}
              data-testid={`mobile-nav-${item.label.toLowerCase()}`}
            >
              <Icon className={`w-6 h-6 ${active ? 'text-blue-500' : ''}`} />
              <span className={`text-xs mt-1 ${active ? 'text-blue-500 font-medium' : ''}`}>
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileBottomNav;
